import React from "react";
import styles from "./Resources.module.scss";
import Button from "../elements/Button";
import LinkTo from "../elements/LinkTo";
import ArrowLeft from "../../svgs/ArrowLeft";
import Section from "../layout/Section";
import Container from "../layout/Container";
import Row from "../layout/Row";

const Resources = ({title, content, link, otherLinks, theme}) => {
    const otherLinksElements = otherLinks && otherLinks.length ? otherLinks.map((item,i) => {
        return ( item && item.linkLink.url && 
            <li key={i}>
                <LinkTo url={item.linkLink.url} target={item.linkLink.target}>{item.linkLink.text}<span>&nbsp;<ArrowLeft /></span></LinkTo>
            </li>
        );
    }) : null;

    const resourcesWithOtherLinks = (
        <>
            <Row className={styles.resources__titleRow}>
                <div className={`${styles.resources__col} ${styles.resources__colWithLinks}`}>
                    {title && <h4>{title}</h4>}
                </div>
            </Row>
            <Row className={styles.resources__linksRow}>
                <div className={`${styles.resources__col} ${styles.resources__colWithLinks}`}>
                    {content &&
                        <div className={styles.resources__content}>
                            <span dangerouslySetInnerHTML={{__html: content}} />
                        </div>
                    }
                    {link && link.url && <Button text={link.text} url={link.url} external={link.target === "_blank"} target={link.target} simpleStyle={true} />}
                </div>
                <div className={`${styles.resources__col} ${styles.resources__colLinksList}`}>
                    {otherLinksElements &&
                        <ul>
                            {otherLinksElements}
                        </ul>
                    }
                </div>
            </Row>
        </>
    );

    const resourcesWithoutOtherLinks = (
        <Row>
            <div className={`${styles.resources__col} ${styles.resources__colWithoutLinks}`}>
                {title && <h4>{title}</h4>}
                {content &&
                    <div className={styles.resources__content}>
                        <span dangerouslySetInnerHTML={{__html: content}} />
                    </div>
                }
                {link && link.url && <Button text={link.text} url={link.url} external={link.target === "_blank"} target={link.target} simpleStyle={true} />}
            </div>
        </Row>
    );

    return title || content || (link && link.url) || otherLinksElements ? (
        <Section className={styles.resources} theme={theme}>
            <Container>
                {otherLinks && otherLinks.length ? resourcesWithOtherLinks : resourcesWithoutOtherLinks}
            </Container>
        </Section>
    ) : null;
};

export default Resources;